import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportPokerMttResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportPokerMttInner() {
    return <PlayerLevelReportBase tab="pokerMtt" columnsSettingsViewType="PlayerLevelReportPokerMtt" />;
}

const PlayerLevelReportPokerMttWithAccess = withAccessCheck(PlayerLevelReportPokerMttInner, playerLevelReportPokerMttResource);

export const PlayerLevelReportPokerMtt = withTraceErrorBoundary(PlayerLevelReportPokerMttWithAccess, ErrorModal);
